import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { hasAnyRole } from "../../Helpers/roles";
import Loading from "../pages/Loading";

const PrivateRoute = ({ allowedRoles, children }) => {
  const { user: authUser, hydrated, isHydrating } = useSelector((x) => x.auth);

  if (!hydrated || isHydrating) {
    return <Loading />;
  }

  if (!authUser) {
    return <Navigate replace to="/login" />;
  }

  if (allowedRoles?.length && !hasAnyRole(authUser, allowedRoles)) {
    return <Navigate replace to="/" />;
  }

  return children;
};

export default PrivateRoute;
